/* ============================================================
   RIPTAG — Scroll Reveal
   Include in theme.liquid: {{ 'riptag-reveal.js' | asset_url | script_tag }}
   ============================================================ */
(function () {
  'use strict';

  var ro;

  function initReveal() {
    if (ro) ro.disconnect();

    ro = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('rt-in');
            ro.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    document.querySelectorAll('.rt-sr:not(.rt-in)').forEach(function (el) {
      ro.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-init after Shopify section renders (Theme Editor)
  document.addEventListener('shopify:section:load', initReveal);
})();
